import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
var lazyQuickModule = new LazyModule(() => import('./lazyQuickOption'));
let MessagePreviewOption: LazyOption = createLazyOption(
    {
        key: 'messagePreview',
        titleStringKey: 'optionTitle_messagePreview',
        searchTermsStringKey: 'optionTitle_messagePreview',
    },
    lazyFullModule,
    m => m.default,
    lazyQuickModule,
    m => m.default
);
export default MessagePreviewOption;
